import axios from 'axios';
import store from '@/store';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

const apiPath = `${store.state.apiPathWithVersion}/session`;

export default {
  async check(updateAnalytics) {
    let apiUrl = store.state.countrySelected.api;
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/check`);
      store.commit('UPDATE_USER', resp.data);

      if (updateAnalytics) {
        EventBus.$emit(keys.updateUserData);
      }

      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
